<template lang="pug">
  // TABLE that displays Broadcast Campaigns
  div
    p(v-if='loading')
    app-table(:data='tableItems', :label='tableFields', v-else, rowBroadcastClick)
</template>

<script>
import { db } from '@/firebase'

const campRef = db.ref('campaign')

export default {
  name: 'broadcast-table',
  data() {
    return {
      usersCount: 0,
      loading: true,
      tableItems: [],
      tableFields: {
        // Campaign Name Start Date  End Date  Audience  Message Email SMS Messenger Sent
        campaign: {
          label: 'Campaign',
          // Campaign Name, campaign message
        },
        startDate: {
          label: 'Start Date',
          sortable: true,
          thStyle: {
            minWidth: '7em',
          },
        },
        endDate: {
          label: 'End Date',
          sortable: true,
          thStyle: {
            minWidth: '7em',
          },
        },
        audience: {
          label: 'Audience',
        },
        platform: {
          label: 'Platforms',
          // icons of devices with color
          thStyle: {
            minWidth: '8em',
          },
        },
        approval: {
          label: 'Approval',
          class: 'text-center',
        },
        sent: {
          label: 'Status',
          class: 'text-center',
        },
        broadcastActions: {
          label: '<i></i>',
          class: 'text-right',
        },
      },
    }
  },
  mounted: function() {
    var msgs
    campRef.on('value', (snapshot) => {
      msgs = []
      Object.entries(snapshot.val()).forEach(
        function([key, val]) {
          var msg = {
            campaign: { campaign: val.message, campaignTitle: val.name },
            startDate: val.start_date,
            endDate: val.end_date,
            platform: { messenger: val.messenger, email: val.email, sms: val.sms },
            audience: val.audience,
            sent: val.sent,
            approval: val.approval,
            broadcastActions: key,
          }
          msgs.unshift(msg)
        })
      console.log(msgs)
      this.loading = false
      this.tableItems = msgs
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/fragments/broadcastTable.vue?9a4fffd8